var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebookIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 14,
    viewBox: "0 0 8 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.05273 13.7114V7.55908H7.12695L7.42578 5.15088H5.05273V3.62158C5.05273 3.28174 5.12598 3.00342 5.27246 2.78662C5.41895 2.56982 5.73828 2.46143 6.23047 2.46143H7.49609V0.316895C7.22656 0.281738 6.93945 0.255371 6.63477 0.237793C6.33008 0.220215 6.02539 0.211426 5.7207 0.211426C5.70898 0.211426 5.69727 0.211426 5.68555 0.211426C5.67383 0.211426 5.66211 0.211426 5.65039 0.211426C4.73633 0.211426 3.99219 0.483887 3.41797 1.02881C2.84375 1.57373 2.55664 2.36182 2.55664 3.39307V5.15088H0.5V7.55908H2.55664V13.7114H5.05273Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookIcon);
export default __webpack_public_path__ + "static/media/facebook-icon.c5d4232f9e2738fa7f8b5d3c4c25f573.svg";
export { ForwardRef as ReactComponent };